module.exports = __webpack_public_path__ + "static/media/logoPatologia.c3776266.svg";